module.exports = __webpack_public_path__ + "static/media/Back.418a16d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svgs/Back.svg
// module id = 388
// module chunks = 0